import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { compareObjects } from '../../../../functions/utils/comapareObjects';
import { LauncherStatesData } from '../../../../hooks/stores/launcherStatesStore';
import { UIData, useUIStore } from '../../../../hooks/stores/uiStore';
import { StateViewInfo, stateViewsInfo } from '../../../../info/stateViewsInfo';
import { VisibilityButton } from '../../stateViewController/VisibilityButton';
import { useScene } from '../../../../context/sceneContext';

export const CurrentViewButton = () => {
  const scene = useScene();
  const [UIData, setUIData] = useUIStore<UIData>();
  const [lastStateViewData, setLastStateViewData] = useState<StateViewInfo>({
    significantLauncherState: ['isAppInstalled', 'false'],
    iconClassName: 'icon-not-installed',
    subIconClassName: undefined,
  } as StateViewInfo);

  const stateViewData =
    Object.values(stateViewsInfo).find((data) =>
      compareObjects(UIData.currentLauncherState, data.significantLauncherState)
    ) || lastStateViewData;

  const visibility = (state: [keyof LauncherStatesData | null, string | null]) => {
    return scene.getSelectedElementsDirectVisibility(state);
  };

  useEffect(() => {
    setLastStateViewData(stateViewData);
  }, [stateViewData]);

  return (
    <Container $visibility={visibility(stateViewData.significantLauncherState)}>
      <SubButtonsLeftContainer className="subButtonsLeft">
        <VisibilityButton forState={stateViewData.significantLauncherState} />
      </SubButtonsLeftContainer>
      <MainButton
        $isActive={compareObjects(stateViewData.significantLauncherState, UIData.currentLauncherState)}
        $computedVisibility={visibility(stateViewData.significantLauncherState)}
        onClick={() => setUIData({ currentLauncherState: stateViewData.significantLauncherState })}
        $isTask={stateViewData.subIconClassName !== undefined}
      >
        <i className={stateViewData.iconClassName} style={{ fontSize: '20px' }} />
        {stateViewData.subIconClassName && (
          <i
            className={stateViewData.subIconClassName}
            style={{ translate: '0 -2px', fontSize: '12px', lineHeight: '12px' }}
          />
        )}
      </MainButton>
      <Label $isActive={compareObjects(stateViewData.significantLauncherState, UIData.currentLauncherState)}>
        Current
      </Label>
    </Container>
  );
};

const Container = styled.div<{ $visibility?: boolean }>`
  position: relative;
  margin-bottom: 15px;

  box-sizing: border-box;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  .subButtonsLeft {
    transition: opacity var(--transition-2);
    opacity: ${({ $visibility }) => ($visibility === false ? 1 : 0)};
  }
  &:hover {
    .subButtonsLeft {
      opacity: 1;
    }
  }
`;

const SubButtonsLeftContainer = styled.div`
  height: 100%;
  position: absolute;
  left: 3px;
  translate: -100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const MainButton = styled.div<{
  $isActive?: boolean;
  $isCurrentStateDifferentFromDisplayed?: boolean;
  $computedVisibility?: boolean;
  $isTask?: boolean;
}>`
  --text-color: var(--main-2);
  --text-color-hovered: var(--main-1);
  --border-color: var(--neutral-3);

  ${({ $isActive, $isCurrentStateDifferentFromDisplayed }) =>
    $isActive &&
    `
      --text-color: var(${$isCurrentStateDifferentFromDisplayed ? '--primary-2' : '--primary-1'});
      --text-color-hovered: var(--primary-1);
      --border-color: var(${$isCurrentStateDifferentFromDisplayed ? '--primary-2' : '--primary-1'});
    `}

  ${({ $computedVisibility }) =>
    $computedVisibility === false &&
    `
    --text-color: var(--error-1);
    --text-color-hovered: var(--error-1);
  `}

  cursor: pointer;
  width: 40px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  color: var(--text-color);
  background-color: var(--neutral-2);
  border: 1px solid var(--border-color);

  border-radius: var(--radius-1);
  ${({ $isTask }) => $isTask && `border-radius: 50%;`}

  transition:
    opacity var(--transition-2),
    background-color var(--transition-2),
    color var(--transition-2),
    border var(--transition-2);
  &:hover {
    background-color: var(--neutral-3);
    color: var(--text-color-hovered);
  }
`;

const Label = styled.div<{
  $isActive: boolean;
}>`
  position: absolute;
  bottom: -25px;
  padding: 3px 7px;
  margin-bottom: 7px;

  font-family: var(--font-1);
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0px 0px 2px #000;
  color: var(--main-2);

  background-color: var(--neutral-1);
  border-radius: 5px;
  overflow: hidden;

  transition: color var(--transition-2);
  ${({ $isActive }) => $isActive && `color: var(--primary-1);`}
`;
